var _path, _path2, _circle, _g, _g2, _g3, _g4, _g5, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCircel(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 606,
    height: 597,
    viewBox: "0 0 606 597",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M529.93 297.934C529.93 426.044 426.076 529.898 297.966 529.898C169.855 529.898 66.0011 426.044 66.0011 297.934C66.0011 169.823 169.855 65.9691 297.966 65.9691C426.076 65.9691 529.93 169.823 529.93 297.934Z",
    stroke: "#020626",
    strokeOpacity: 0.07,
    strokeWidth: 1.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M465.15 297.931C465.15 390.266 390.298 465.118 297.964 465.118C205.629 465.118 130.777 390.266 130.777 297.931C130.777 205.597 205.629 130.745 297.964 130.745C390.298 130.745 465.15 205.597 465.15 297.931Z",
    stroke: "#020626",
    strokeOpacity: 0.07,
    strokeWidth: 1.2
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 298.5,
    cy: 298.468,
    r: 297.274,
    stroke: "#020626",
    strokeOpacity: 0.07,
    strokeWidth: 1.2
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_1_329)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 595.316,
    cy: 321.307,
    rx: 5.3097,
    ry: 5.3097,
    fill: "#166FD3"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_1_329)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 457.257,
    cy: 130.15,
    rx: 5.3097,
    ry: 5.3097,
    fill: "#BAE900"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_1_329)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 378.678,
    cy: 443.413,
    rx: 5.3097,
    ry: 5.3097,
    fill: "#FD5B38"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_f_1_329)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 67.5219,
    cy: 285.19,
    rx: 5.3097,
    ry: 5.3097,
    fill: "#D2A98E"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_f_1_329)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 84.5133,
    cy: 92.9777,
    rx: 5.3097,
    ry: 5.3097,
    fill: "#FD5B38"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_1_329",
    x: 585.006,
    y: 310.997,
    width: 20.6194,
    height: 20.6194,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "effect1_foregroundBlur_1_329"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_1_329",
    x: 446.948,
    y: 119.84,
    width: 20.6194,
    height: 20.6194,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "effect1_foregroundBlur_1_329"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_1_329",
    x: 368.368,
    y: 433.104,
    width: 20.6194,
    height: 20.6194,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "effect1_foregroundBlur_1_329"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_1_329",
    x: 57.2122,
    y: 274.88,
    width: 20.6194,
    height: 20.6194,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "effect1_foregroundBlur_1_329"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_f_1_329",
    x: 74.2036,
    y: 82.668,
    width: 20.6194,
    height: 20.6194,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "effect1_foregroundBlur_1_329"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircel);
export default __webpack_public_path__ + "static/media/circel.a3fe04270aa9704fac9b84b45d5f3482.svg";
export { ForwardRef as ReactComponent };